@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.label-meter {
  position: relative;
  height: 150px;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.buying-labels {
  display: flex;
  align-items: center;
  height: 20px;
  font-size: 14px;
  white-space: nowrap;

  :first-child {
    margin-right: 5px;
  }
  .loading {
    height: 20px;
    width: 20px;
  }
}

.meter-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 40px;
  font-size: 14px;

  .count {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 16px;

    > svg {
      height: 30px;
      width: 30px;
      color: @label-batch-status--meter-count--fill-color;
    }

    &.complete-success {
      color: @label-batch-status--meter-complete--success--text-color;

      > svg {
        transform: scale(0.4);
      }
    }
  }
}

.primary-stroke {
  stroke: @label-batch-status--meter--stroke-color;
}

.warning-stroke {
  stroke: @label-batch-status--meter--warning--stroke-color;
}

.error-stroke {
  stroke: @label-batch-status--meter--error--stroke-color;
}

.progress-wrap {
  width: 200px;
  height: 30px;
  padding: 10px;
  align-items: center;
}
